export default __webpack_public_path__ + "static/demand360-dots-ffeec201b485b273a1991ab983409825.jpg";